import React from "react";

const SupplierChange = (props) => {
  // Determine background color based on change type

  const { change_data, display_change_type, font_style, font_size } = props;

  const backgroundColor =
    change_data?.supplier_changes_details_change_type === 1
      ? "bg-[#309C4426]"
      : change_data?.supplier_changes_details_change_type === -1
      ? "bg-[#F0443826]"
      : "";

  // Determine if the content should be displayed
  const shouldDisplayContent =
    display_change_type === 0 ||
    display_change_type === change_data?.supplier_changes_details_change_type ||
    change_data?.supplier_changes_details_change_type === 0;

  return (
    <div>
      <div className={`${backgroundColor} h-fit   `}>
        {shouldDisplayContent && (
          <p
            className="my-0.5 px-2 py-2   "
            style={{
              fontFamily: font_style,
              fontSize: font_size,
              lineHeight: 1,
            }}
          >
            {change_data?.supplier_changes_details_change_type === 0 ? change_data?.supplier_changes_details_content.slice(0, 100) : change_data?.supplier_changes_details_content}
          </p>
        )}
      </div>
    </div>
  );
};

export default SupplierChange;

// font-opensans
// font-mono
